import { format } from "date-fns";
import { useState } from "react";
import { Modal } from "antd";
import { IoClose } from "react-icons/io5";
import { toast } from "react-toastify";
import { useAuth } from "../../context/auth";
import ModalProposta from "../Proposta/ModalProposta";
import {
  getDescricaoTipoProposta,
  parseAxis,
} from "../Proposta/utils/propostaConstants";
import { CardLi, CardFieldLabel, CardFieldValue } from "./styles";

export interface IKanbanProposalItem {
  id: number;
  status: number;
  cliente: string;
  construtora: string;
  descricao_imovel: string;
  bloco?: string;
  uuid?: string;
  created_at?: string | Date;
  updated_at: string | Date;
  valor: number;
  corretor?: string;
  equipe?: string;
  tipo_proposta?: string | number;
  axis?: 0 | 1 | "0" | "1" | boolean | null;
}

type CardProposalProps = {
  card: IKanbanProposalItem;
  color: string;
  columnLabel: string;
  onRefresh?: () => void;
};

export function CardProposal({
  card,
  color,
  columnLabel,
  onRefresh,
}: CardProposalProps) {
  const { api } = useAuth();
  const [modalOpen, setModalOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const canDelete = card.status === -1;
  const isAxis = parseAxis(card.axis) === 1;

  const valorFormatado =
    card.valor != null
      ? `R$ ${Number(card.valor).toLocaleString("pt-br", {
          minimumFractionDigits: 2,
        })}`
      : "Não informado";

  const dataFormatada = card.updated_at
    ? format(new Date(card.updated_at), "dd/MM/yyyy")
    : "Não informado";

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    Modal.confirm({
      title: "Atenção!",
      content: "Você tem certeza de que deseja excluir esta proposta?",
      okText: "Sim",
      cancelText: "Não",
      zIndex: 11000,
      onOk: async () => {
        setDeleting(true);
        try {
          await api.delete(`/sin/proposta/${card.id}`);
          toast.success("Proposta excluída com sucesso!");
          onRefresh?.();
        } catch (error: any) {
          toast.error(
            `Ocorreu um erro ao excluir a proposta. (${error?.message || ""})`,
          );
        } finally {
          setDeleting(false);
        }
      },
    });
  };

  return (
    <>
      <ModalProposta
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSuccess={onRefresh}
        id_proposta={card.id}
        status={card.status}
        kanbanTag={{
          label: columnLabel,
          color,
        }}
      />

      <CardLi onClick={() => setModalOpen(true)}>
        {canDelete && (
          <button
            type="button"
            className="card-delete"
            onClick={handleDelete}
            disabled={deleting}
            aria-label="Excluir proposta"
          >
            <IoClose size={18} />
          </button>
        )}
        <div className="basel" style={{ background: color }} />
        <div className="li_content">
          <div>
            <CardFieldLabel>Corretor</CardFieldLabel>
            <CardFieldValue style={{ color }}>
              {card.corretor || "Não informado"} |{" "}
              {card.equipe || "Não informado"}
            </CardFieldValue>
          </div>
          <div>
            <CardFieldLabel>Imóvel</CardFieldLabel>
            <CardFieldValue>
              {card.descricao_imovel || "Não informado"}
            </CardFieldValue>
          </div>
          <div>
            <CardFieldLabel>Proponente</CardFieldLabel>
            <CardFieldValue>{card.cliente || "Não informado"}</CardFieldValue>
          </div>
          <div className="row-split">
            <div>
              <CardFieldLabel>Valor da proposta</CardFieldLabel>
              <CardFieldValue>{valorFormatado}</CardFieldValue>
            </div>
            <div className="tipo-badge" style={{ color }}>
              {getDescricaoTipoProposta(card.tipo_proposta)}
            </div>
          </div>
          <div className="row-split">
            <div>
              <CardFieldLabel>Data da proposta</CardFieldLabel>
              <CardFieldValue>{dataFormatada}</CardFieldValue>
            </div>
            <div className="card-id-wrap">
              {isAxis ? <span className="axis-badge">AXIS</span> : null}
              <span className="card-id">#{card.id}</span>
            </div>
          </div>
        </div>
      </CardLi>
    </>
  );
}
